import { useEffect, useRef } from "react";
import actLogo from "../assets/actlogo.png";
import aqaLogo from "../assets/aqa_icon.png";
import edexcelLogo from "../assets/edexcel_icon.png";

const COURSES = [
  {
    id: "ib",
    name: "IB",
    track: "International Curricula",
    desc: "Personalized support for IB learners across HL & SL subjects.",
    accent: "#97D8C4",
    href: "/ib",
    image:
      "https://asset.sparkl.me/pb/poc-folder/mPEOQQzLqAIkdE2ru0oiRWWJkH47ebCOE16tWhrl.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(151,216,196,0.22) 0%, rgba(151,216,196,0.06) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FFFC 100%)",
  },
  {
    id: "igcse",
    name: "IGCSE",
    track: "International Curricula",
    desc: "Cambridge-focused conceptual learning with structured practice.",
    accent: "#97D8C4",
    href: "/cie",
    image:
      "https://asset.sparkl.me/pb/poc-folder/8JNaXBAdneJPPBRUZomXc72yPdThEqOvb6DTMMHo.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(151,216,196,0.22) 0%, rgba(151,216,196,0.06) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FFFC 100%)",
  },
  {
    id: "sat",
    name: "SAT",
    track: "Global Test Prep",
    desc: "Digital SAT prep with guided practice and adaptive review.",
    accent: "#B9D8FF",
    href: "/sat",
    image:
      "https://asset.sparkl.me/pb/poc-folder/Xst6pq5tiVBxCeOYZbQoxLadkoGDsxR5G3LtmjfT.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(185,216,255,0.24) 0%, rgba(185,216,255,0.07) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)",
  },
  {
    id: "act",
    name: "ACT",
    track: "Global Test Prep",
    desc: "Structured ACT preparation with timed strategy and accuracy.",
    accent: "#B9D8FF",
    href: "/act",
    image: actLogo,
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(185,216,255,0.24) 0%, rgba(185,216,255,0.07) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)",
  },
  {
    id: "aps",
    name: "APs",
    track: "Global Test Prep",
    desc: "Advanced Placement support across STEM, humanities, and more.",
    accent: "#B9D8FF",
    href: "/ap",
    image:
      "https://asset.sparkl.me/pb/poc-folder/6ntXovGxqo9cpo8MT1ecmlBhxvtY3RbzQvqM2NUC.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(185,216,255,0.24) 0%, rgba(185,216,255,0.07) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)",
  },
  {
    id: "aqa",
    name: "AQA",
    track: "International Curricula",
    desc: "Build strong subject knowledge, critical thinking, and exam confidence.",
    accent: "#97D8C4",
    href: "/aqa",
    image: aqaLogo,
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(151,216,196,0.22) 0%, rgba(151,216,196,0.06) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FFFC 100%)",
  },
  {
    id: "pearson-edexcel",
    name: "Pearson Edexcel",
    track: "International Curricula",
    desc: "Strengthen subject understanding, practical abilities, and build academic confidence.",
    accent: "#97D8C4",
    href: "/pearson-edexcel",
    image: edexcelLogo,
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(151,216,196,0.22) 0%, rgba(151,216,196,0.06) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FFFC 100%)",
  },
  {
    id: "jee",
    name: "JEE",
    track: "Indian Competitive Exams",
    desc: "Concept mastery in Physics, Chemistry & Maths for engineering.",
    accent: "#faac00",
    href: "/jee",
    image:
      "https://asset.sparkl.me/pb/poc-folder/r7wod0R6pYrR5l6BN9r0Ejf6TIiSUrxzEwtAofwP.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(248,204,107,0.24) 0%, rgba(248,204,107,0.07) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #FFFCF3 100%)",
  },
  {
    id: "neet",
    name: "NEET",
    track: "Indian Competitive Exams",
    desc: "Focused preparation in Biology, Chemistry & Physics for medical.",
    accent: "#faac00",
    href: "/neet",
    image:
      "https://asset.sparkl.me/pb/poc-folder/ZSzJRDu6NL3v1jdiFbF2JGJenjtcB5r6COjFSptP.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(248,204,107,0.24) 0%, rgba(248,204,107,0.07) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #FFFCF3 100%)",
  },
  {
    id: "foundation",
    name: "Foundation",
    track: "School Foundation",
    desc: "Build strong fundamentals early with concept-first learning.",
    accent: "#FFD8BF",
    href: "/foundation",
    image:
      "https://asset.sparkl.me/pb/poc-folder/ZJBvSkUTUpYh4v0Cwt6h0TRDGYvMQVJrtgURc4QG.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(255,216,191,0.26) 0%, rgba(255,216,191,0.08) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #FFF9F5 100%)",
  },
  {
    id: "boardprep",
    name: "BoardPrep",
    track: "Board Prep",
    desc: "Targeted exam prep across CBSE, ICSE & State Boards.",
    accent: "#97D8C4",
    href: "/cbse",
    image:
      "https://asset.sparkl.me/pb/poc-folder/x8rvRQvSdHNdiwhLZufkTlWbrMcH2SKmDRJ1KHNW.png",
    gradient:
      "radial-gradient(circle at 88% 18%, rgba(151,216,196,0.22) 0%, rgba(151,216,196,0.06) 38%, transparent 64%), linear-gradient(135deg, #FFFFFF 0%, #F8FFFC 100%)",
    wide: true,
  },
];

export default function SparklCoursesSection() {
  const cardRefs = useRef([]);
  const headRef = useRef(null);

  useEffect(() => {
    const els = [headRef.current, ...cardRefs.current].filter(Boolean);
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <section className="sp-cr" id="programs" data-testid="courses-section">
      <div className="sp-cr-bg" aria-hidden="true" />

      <div className="sp-cr-inner">
        <div ref={headRef} className="sp-cr-head" data-testid="courses-head">
          <h2 className="sp-cr-title">
            Choose your{" "}
            <span className="sp-grad-word">academic track.</span>
          </h2>
          <p className="sp-cr-sub">
            From school boards to international curricula and competitive
            exams, Sparkl pairs expert 1-on-1 tutoring with AI Tutor support
            for every learning goal.
          </p>
        </div>

        <div className="sp-cr-grid" data-testid="courses-grid">
          {COURSES.map((c, i) => (
            <a
              key={c.id}
              ref={(el) => (cardRefs.current[i] = el)}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`sp-cr-card ${c.wide ? "is-wide" : ""}`}
              style={{
                background: c.gradient,
                "--accent": c.accent,
                "--delay": `${(i % 2) * 80 + 40}ms`,
              }}
              data-testid={`course-card-${c.id}`}
            >
              <div className="sp-cr-card-body">
                <span className="sp-cr-card-track">{c.track}</span>
                <h3 className="sp-cr-card-name">{c.name}</h3>
                <p className="sp-cr-card-desc">{c.desc}</p>
                <span className="sp-cr-card-cta" data-testid={`know-more-${c.id}`}>
                  Know more
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M3 8h10M9 4l4 4-4 4"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <div className="sp-cr-card-art">
                <div className="sp-cr-card-art-inner">
                  <img
                    src={c.image}
                    alt={`${c.name} academic illustration`}
                    loading="lazy"
                  />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
